import apiMiddleware from "../../../api/apiMiddleware";

// Fetch all suppliers with pagination
export const getSuppliers = async (page = 1) => {
  const response = await apiMiddleware.get(`admin-suppliers?page=${page}`);
  return response.data.data;
};

// Search suppliers
export const searchSuppliers = async ({ search, page = 1 }) => {
  const params = new URLSearchParams({
    search,
    page: String(page),
  });
  const response = await apiMiddleware.get(`admin-suppliers?${params.toString()}`);
  return response.data.data;
};

// Get supplier by ID
export const getSupplierById = async (id) => {
  const response = await apiMiddleware.get(`admin-supplier/${id}`);
  return response.data;
};

// Create new supplier
export const createSupplier = async (supplierData) => {
  const response = await apiMiddleware.post("admin-suppliers", supplierData);
  return response.data;
};

// Update supplier
export const updateSupplier = async ({ id, supplierData }) => {
  supplierData.append("_method", "PUT");
  const response = await apiMiddleware.post(
    `admin-supplier/${id}`,
    supplierData
  );
  return response.data;
};

// Delete supplier
export const deleteSupplier = async (id) => {
  await apiMiddleware.delete(`admin-suppliers/${id}`);
  return id;
};
